/* eslint-disable jsx-a11y/anchor-is-valid */
import { useTranslation } from "react-i18next";
import { Loader, Modal } from "../../../components";
import locale from "../../../constants/locale";
import { useEffect, useRef, useState } from "react";
import { getChat } from "../../../services/chathub";
import { useStore } from "../../../stores";
import { observer } from "mobx-react-lite";
import { useHistory } from "react-router";
import routes from "../../../constants/routes";
import { Chat } from "../../../models";
import Conversation from "./Conversation";

const ChatQuickView = ({
  chatId,
  onClose,
}: {
  chatId: number;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const { selectedBot, routeTo } = useStore("bots");
  const { selectedChat, setSelectedChat } = useStore("chats");
  const history = useHistory();
  const previousChatRef = useRef<Chat | undefined>(undefined);
  const hasSnapshotRef = useRef(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!selectedBot || !chatId) return;

    if (!hasSnapshotRef.current) {
      previousChatRef.current = selectedChat;
      hasSnapshotRef.current = true;
    }

    let cancelled = false;
    setLoading(true);
    getChat(
      selectedBot.id,
      selectedBot.key,
      selectedBot.password,
      chatId
    ).then((chat) => {
      if (cancelled) return;
      if (chat) {
        setSelectedChat(chat);
      }
      setLoading(false);
    });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatId, selectedBot]);

  useEffect(() => {
    return () => {
      if (hasSnapshotRef.current) {
        setSelectedChat(previousChatRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openChat = () => {
    history.push(routeTo(routes.chats).replace(":chatId?", `${chatId}`));
    onClose();
  };

  return (
    <Modal
      onClose={onClose}
      isOpen
      title={() => (
        <div className="is-flex">
          <span className="is-5 title">{t(locale.chat)}</span>
          <a onClick={openChat} className="ml-1">
            {t(locale.openFullView)}
          </a>
        </div>
      )}
      isLargeXLScreen
    >
      <div
        className="is-flex is-relative"
        style={{
          height: "100%",
        }}
      >
        {loading ? (
          <div className="loaderClass">
            <Loader />
          </div>
        ) : (
          <Conversation embeddedChatId={chatId} />
        )}
      </div>
    </Modal>
  );
};

export default observer(ChatQuickView);
